
import React, { Component } from 'react';
import Header from "../images/NADRC-Upload-Banner.jpg"
import Moment from 'moment';
import Layout from '../components/layout'
import Addresource from '../images/myaccount.png'
import Updateresource from '../images/addaccount.png'
import Instruction from '../images/instruction.png'
import strapi from '../images/strapi.png'
import { FaPlus, FaSearch } from 'react-icons/fa'; // Importing icons from react-icons



class SubmitRegistration extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentDate: new Date(),
            file1: null,
            file2: null,
            file3: null,
            file4: null,
            file4: null,
            nid: [Moment(new Date()).format("YYYY") + Moment(new Date()).format("MM") + Moment(new Date()).format("DD") + Moment(new Date()).format("hh") + Moment(new Date()).format("mm") + Moment(new Date()).format("ss")],
            title: "",
            category: "",
            bodyValue: "",
            created: Moment(new Date()).format("yyyy-MM-DDTHH:mm:ss"),
            ndrcKeywords: ""
        }
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        //this.onChangeImageHandler = this.onChangeImageHandler.bind(this)
        this.onChangeImageHandler1 = this.onChangeImageHandler1.bind(this)
        this.onChangeImageHandler2 = this.onChangeImageHandler2.bind(this)
        this.onChangeImageHandler3 = this.onChangeImageHandler3.bind(this)
        this.onChangeImageHandler4 = this.onChangeImageHandler4.bind(this)
        this.onChangeImageHandler5 = this.onChangeImageHandler5.bind(this)
    }



    onChange = e => this.setState({ [e.target.name]: e.target.value });
    onChangeImageHandler1 = e => this.setState({ file1: e.target.files[0] });
    onChangeImageHandler2 = e => this.setState({ file2: e.target.files[0] });
    onChangeImageHandler3 = e => this.setState({ file3: e.target.files[0] });
    onChangeImageHandler4 = e => this.setState({ file4: e.target.files[0] });
    onChangeImageHandler5 = e => this.setState({ file5: e.target.files[0] });

    //onChangeImageHandler4 = e => this.setState({ fileName: e.target.files[0].name, file1: e.target.files[0], file2: e.target.files[0], file3: e.target.files[0], file4: e.target.files[0] });


    onSubmit = (e) => {
        e.preventDefault();
        e.preventDefault();
        e.stopPropagation();

        const formData = new FormData();
        formData.append('nid', this.state.nid);
        formData.append('title', this.state.title);
        formData.append('category', this.state.category);
        formData.append('bodyValue', this.state.bodyValue);
        formData.append('created', this.state.created);
        formData.append('ndrcKeywords', this.state.ndrcKeywords);
        formData.append('file1', this.state.file1);
        formData.append('file2', this.state.file2);
        formData.append('file3', this.state.file3);
        formData.append('file4', this.state.file4);
        formData.append('file5', this.state.file5);

        fetch(process.env.REACT_APP_LOGIC_APP_URL, {
            method: "POST",
            headers: {
                "Content-Type": "multipart/form-data , boundary=?"

            },
            body: formData
        })
            .then(function (res) {
                if (res.ok) {
                    console.log(formData)
                    alert("Perfect! ");
                } else if (res.status == 401) {
                    alert("Oops! ");
                }
            }, function (e) {
                alert(formData);
            });
        this.props.history.push('/Thankyou');

    };







    render() {

        console.log(this.state)


        return (

            <div>
                <Layout>


                    <div class="row card-header pt-2 text-sm" style={{ paddingBottom: 20 + "px" }} ><span style={{ paddingLeft: 10 + "px" }}>Home</span></div>

                    <div class="row body_content" style={{ minHeight: "400px" }}>




                        <div class="row body_content" style={{ minHeight: "600px" }}>
                            <div style={{ minHeight: "200px" }}>
                                <h2 class="text-center text-4xl lg:text-6xl text-black font-bold">Resources</h2>
                                <br />
                                <div class="md:p-2 mb-6 mx-auto md:text-center space-y-4 lg:mx-24">
                                    <div className="grid grid-cols-1 sm:colsrow-auto gap-10 sm:grid-cols-2 w-3/4 mx-auto" id="database">
                                        <div className="sm:col-span-1 pt-4 pl-2 lg:w-full">
                                            <a class="block" href="/add-resource">
                                                <div className="blue-black-card">
                                                    <div className="icon-container">
                                                        <FaPlus size={80} color="white" />
                                                    </div>
                                                    <div><h4 class="text-center menu_title text-3xl" tabindex="0">Add <br />Resource</h4></div>
                                                </div>
                                            </a>
                                        </div>
                                        <div className="sm:col-span-1 pt-4 pl-2 lg:w-full">
                                            <a class="block" href="/view-resources">
                                                <div className="blue-black-card">
                                                    <div className="icon-container">
                                                        <FaSearch size={80} color="white" />
                                                    </div>
                                                    <div><h4 class="text-center menu_title text-3xl" tabindex="0">View/Edit <br />Resources</h4></div>
                                                </div>
                                            </a>
                                        </div>

                                    </div>

                                </div>

                            </div>
                        </div>
                    </div >
                    <div className="sm:col-span-1 pt-4 mb-24 w-full bg-gray-100">
                        <div className="sm:col-span-1 py-8 lg:w-full">
                            <div className="">
                                <div className="text-center text-4xl font-bold">
                                    Need Help?
                                </div>
                                <a
                                    className="blue-black-button block text-white text-center py-1 px-6 rounded-xl mt-4 mx-auto w-72"
                                    href="/"
                                    style={{ display: "inlineBlock" }}
                                >
                                    <p class="menu_title text-2xl my-2" tabindex="0">APS Toolkit Guide</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </Layout>
            </div >

        );
    }
}



export default SubmitRegistration;

